import { FC } from 'react'
import { i18n as I18n } from 'builder/utils/i18n'
import { useMainAppContext } from '../context/TemplatesGuestContext'
import { Container, Step, StepNumber, StepTitle } from './styles'

type TemplateGuestStepsProps = {
  userCategoryPageSelection?: boolean
}

const TemplateGuestSteps: FC<TemplateGuestStepsProps> = ({ userCategoryPageSelection }) => {
  const { currentStep } = useMainAppContext()
  const NAVBAR_STEPS = [
    {
      text: userCategoryPageSelection
        ? I18n.t('builder.sign_up.choose_template')
        : I18n.t('builder.sign_up.enter_details'),
      step: 0,
    },
    {
      text: userCategoryPageSelection
        ? I18n.t('builder.sign_up.enter_details')
        : I18n.t('builder.sign_up.choose_template'),
      step: 3,
    },
    { text: I18n.t('builder.sign_up.download_resume'), step: 5 },
  ]

  let stepToCheck = userCategoryPageSelection ? 3 : currentStep

  return (
    <Container>
      {NAVBAR_STEPS.map((item, i) => (
        <Step key={i}>
          <StepNumber visited={item.step <= stepToCheck}>{i + 1}</StepNumber>
          <StepTitle visited={item.step <= stepToCheck}>{item.text}</StepTitle>
        </Step>
      ))}
    </Container>
  )
}

export default TemplateGuestSteps
